// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const GET_INBOX_REQUESTS_SUCCESS = "GET_INBOX_REQUESTS_SUCCESS";
const GET_RECEIVE_INBOX_REQUESTS_SUCCESS = "GET_RECEIVE_INBOX_REQUESTS_SUCCESS";
const GET_RECEIVED_INBOX_REQUEST_SUCCESS = "GET_RECEIVED_INBOX_REQUEST_SUCCESS";
const GET_INBOX_REQUEST_STATE_DIAGRAM_SUCCESS =
  "GET_INBOX_REQUEST_STATE_DIAGRAM_SUCCESS";
const GET_INBOX_REQUEST_FORM_FIELDS_SUCCESS =
  "GET_INBOX_REQUEST_FORM_FIELDS_SUCCESS";
const GET_INBOX_REQUEST_FORM_FIELDS_FAILED =
  "GET_INBOX_REQUEST_FORM_FIELDS_FAILED";
const STORE_INBOX_REQUEST_SUCCESS = "STORE_INBOX_REQUEST_SUCCESS";
const UPDATE_INBOX_REQUEST_SUCCESS = "UPDATE_INBOX_REQUEST_SUCCESS";
const DESTROY_APPROVE_INBOX_REQUEST_SUCCESS =
  "DESTROY_APPROVE_INBOX_REQUEST_SUCCESS";
const DESTROY_INBOX_REQUEST_SUCCESS = "DESTROY_INBOX_REQUEST_SUCCESS";
const ACCEPT_ALL_REQUEST_SUCCESS = "ACCEPT_ALL_REQUEST_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------
/**
 *
 * @param {Number} payload
 * @param {String} status
 * @return {{type: String, payload: Object}}
 * @private
 */
function _acceptAllSuccess(payload) {
  return {
    type: ACCEPT_ALL_REQUEST_SUCCESS,
    payload:payload,
  };
}
/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexRequestsSuccess(payload) {
  return {
    type: GET_INBOX_REQUESTS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: string, payload: *}}
 */
function _indexReceiveRequestsSuccess(payload) {
  return {
    type: GET_RECEIVE_INBOX_REQUESTS_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _showRequestStateDiagramSuccess(payload) {
  return {
    type: GET_INBOX_REQUEST_STATE_DIAGRAM_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _showRequestSuccess(payload) {
  return {
    type: GET_RECEIVED_INBOX_REQUEST_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {*} payload
 * @return {{type: object, payload: *}}
 */
function _indexRequestFormFieldsSuccess(payload) {
  return {
    type: GET_INBOX_REQUEST_FORM_FIELDS_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @return {{type: object, payload: *}}
 */
function _indexRequestFormFieldsFailed() {
  return {
    type: GET_INBOX_REQUEST_FORM_FIELDS_FAILED,
    payload: [],
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_INBOX_REQUEST_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _updateSuccess(payload) {
  return {
    type: UPDATE_INBOX_REQUEST_SUCCESS,
    payload: payload.data,
  };
}

/**
 *
 * @param {Number} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _destroySuccess(payload) {
  return {
    type: DESTROY_INBOX_REQUEST_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {Object} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _approveSuccess(payload) {
  return {
    type: DESTROY_APPROVE_INBOX_REQUEST_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------
/**
 * @param {object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequests(params = {}, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/requests", { params })
      .then((r) => {
        dispatch(_indexRequestsSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}
/**
 *
 * @param {Object} params
 * @param {String} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function acceptAll(items, data, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (app.can("Request@approve")) {
      let loader = app.loading(app.translate("در حال بروزرسانی"));
      api
        .put(`/Requests/GroupApprove`, {
          data: { acceptance: data, approvedRequestIds: items },
        })
        .then((r) => {
          dispatch(_acceptAllSuccess(r));
          loader.hide(() =>
            app.message(app.translate("بروزرسانی با موفقت انجام شد"))
          );
          callback(undefined, data);
        })
        .catch((err) => {
          loader.hide(() =>
            app.error(
              err,
              "routes.home.attendance.clocking",
              "عملیات بروزرسانی با شکست مواجه شد!",
              app.translate(
                "routes.home.attendance.clocking.Changing Status Clocking Failed"
              )
            )
          );
          callback(err);
        });
    }
  };
}
/**
 * @param {Object} params
 * @param {function} callback
 * @return {Function}
 */
export function getReceiveRequests(params = {}, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/user/requests/received`, { params })
      .then(async (r) => {
        dispatch(_indexReceiveRequestsSuccess(r));        
        const ids = (r?.data?.receivedRequests || [])
          .map((el) => el?.requestId)
          .filter((id) => id != null); // حذف null/undefined
        console.log("23423rwefsefsdsd", r);
        
        await api
          .post("/Requests/NotApprovedName", { data: ids })
          .then((res) => callback(r, res));
        // callback(r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 * @param {Number} id
 * @param {Object} params
 * @param {function} callback
 * @return {Function}
 */
export function getRequest(id, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/requests/received/${id}`, { params })
      .then((r) => {
        dispatch(_showRequestSuccess(r));
        callback(r);
      })
      .catch((e) => {
        // console.log('e',e);
      });
  };
}

/**
 * @param {Number} id
 * @param {function} callback
 * @return {Function}
 */
export function getRequestStateDiagram(id, callback = (r) => {}) {
  return (dispatch, gs, api) => {
    api
      .get(`/requests/${id}/state_diagram`)
      .then((r) => {
        dispatch(_showRequestStateDiagramSuccess(r));
        callback(r);
      })
      .catch((e) => {});
  };
}

/**
 * @return {Function}
 */
export function emptyStateDiagram() {
  return _showRequestStateDiagramSuccess({ data: { state_diagram: [] } });
}

/**
 *
 * @param {function} callback
 * @return {Function}
 */
export function getRequestFormFields(callback = (r) => {}) {
  return (dispatch, gs, api) => {
    api
      .get("/requests/forms/fields")
      .then((r) => {
        dispatch(_indexRequestFormFieldsSuccess(r));
        callback(r);
      })
      .catch((e) => {
        dispatch(_indexRequestFormFieldsFailed());
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.Adding New Request")
    );
    api
      .post(`/requests${acceptAll}`, { data })
      .then((r) => {
        if (r.data.id) {
          dispatch(_storeSuccess(r));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.requests.New Request Added Successfully"
              )
            )
          );
          callback();
        } else {
          loader.hide(() =>
            app.message(app.translate("routes.home.requests.Please check it"))
          );
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.dashboard",
            "خطا در ارسال اطلاعات",
            app.translate("routes.home.requests.Adding New Request Failed")
          )
        );
      });
  };
}

/**
 *
 * @param {Number} request
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function update(request, data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    api
      .put(`/requests/${request}${acceptAll}`, { data })
      .then((r) => {
        if (r.data.request) {
          dispatch(_updateSuccess(r));
          callback(r);
        } else {
          callback(r);
        }
      })
      .catch((e) => {});
  };
}

/**
 *
 * @param {Number} request
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function destroy(request, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.Removing Request")
    );
    api
      .delete(`/requests/${request}`, { params })
      .then((r) => {
        if (!app._.isEmpty(r.data) && (r.data.confirm || r.data.notice)) {
          loader.hide(() =>
            app.message(app.translate("routes.home.requests.Please check it"))
          );
          callback(r, "destroy");
        } else {
          dispatch(_destroySuccess(request));
          loader.hide(() =>
            app.message(
              app.translate("routes.home.requests.Request Removed Successfully")
            )
          );
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() =>
          app.error(
            e,
            "routes.home.requests.dashboard",
            "عملیات حذف با شکست مواجه شد",
            app.translate("routes.home.requests.Removing Request Failed")
          )
        );
      });
  };
}

/**
 *
 * @param {Number} request
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
let loading = false;
export function accept(request, data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    // Prevent multiple requests
    if (loading) return;

    loading = true; // Set loading to true to block further requests
    let loader = app.loading(
      app.translate("routes.home.requests.Accepting Request")
    );

    api
      .put(`/requests/approve${acceptAll}`, { data })
      .then((r) => {
        if (!app._.isEmpty(r.data) && (r.data.confirm || r.data.notice)) {
          loader.hide(() =>
            app.message(app.translate("routes.home.requests.Please check it"))
          );
          callback(r, "accept");
        } else {
          dispatch(_approveSuccess({ id: request, status: data.acceptance }));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.requests.Accepting Request Successfully"
              ),
              "success"
            )
          );
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() => {
          if (e.response && e.response.data) {
            callback(e.response.data, "accept");
            return app.translate("routes.home.requests.Please check it");
          } else {
            return app.translate(
              "routes.home.requests.Accepting Request Failed"
            );
          }
        });
      })
      .finally(() => {
        loading = false; // Reset loading to allow future requests
      });
  };
}

/**
 *
 * @param {Number} request
 * @param {Object} data
 * @param {string} acceptAll
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function reject(request, data, acceptAll, callback = () => {}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(
      app.translate("routes.home.requests.Rejecting Request")
    );
    api
      .put(`/requests/approve${acceptAll}`, { data })
      .then((r) => {
        if (!app._.isEmpty(r.data) && (r.data.confirm || r.data.notice)) {
          loader.hide(() =>
            app.message(app.translate("routes.home.requests.Please check it"))
          );
          callback(r, "reject");
        } else {
          dispatch(_approveSuccess({ id: request, status: data.acceptance }));
          loader.hide(() =>
            app.message(
              app.translate(
                "routes.home.requests.Rejecting Request Successfully"
              ),
              "success"
            )
          );
          callback(r);
        }
      })
      .catch((e) => {
        loader.hide(() => {
          if (e.response && e.response.data) {
            callback(e.response.data, "reject");
            return app.translate("routes.home.requests.Please check it");
          } else {
            return app.translate(
              "routes.home.requests.Rejecting Request Failed"
            );
          }
        });
      });
  };
}

/**
 *
 * @return {{type: string, payload: *}}
 */
export function emptyRequests() {
  return _indexRequestsSuccess({ data: { requests: [] }, meta: {} });
}

/**
 *
 * @return {{type: Object, payload: *}}
 */
export function emptyRequest() {
  return _showRequestSuccess({ data: { request: null } });
}

/**
 *
 * @return {{type: Object, payload: *}}
 */
export function emptyRequestUserPositions() {
  return _indexRequestUserPositionsSuccess({ data: { users: null } });
}

/**
 *
 * @return {{type: Object, payload: *}}
 */
export function emptyRequestFormField() {
  return _indexRequestFormFieldsSuccess({ data: { requestFormFields: [] } });
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(
  state = {
    requests: [],
    request: {},
    requestStateDiagram: [],
    requestForms: [],
    requestFormFields: [],
    requestUserPositions: {},
    meta: {},
    clockings: [],
    clocking: {},
    meta: {},
  },
  action
) {
  let requests = app._.cloneDeep(state.requests);
  let _index;
  let clockings;
  let _clock;
  let _temp;
  switch (action.type) {
    case GET_INBOX_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        requests: action.payload.data.requests,
        meta: action.payload.meta,
      });
    case GET_RECEIVE_INBOX_REQUESTS_SUCCESS:
      return Object.assign({}, state, {
        requests: action.payload.data.receivedRequests,
        meta: action.payload.meta,
      });
    case GET_RECEIVED_INBOX_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        request: action.payload.receivedRequest,
      });
    case GET_INBOX_REQUEST_STATE_DIAGRAM_SUCCESS:
      return Object.assign({}, state, {
        requestStateDiagram: action.payload.stateDiagram,
      });
    case GET_INBOX_REQUEST_FORM_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        requestFormFields: action.payload.requestFormFields,
      });
    case GET_INBOX_REQUEST_FORM_FIELDS_FAILED:
      return Object.assign({}, state, {
        requestFormFields: [],
      });
    case STORE_INBOX_REQUEST_SUCCESS:
      let _requests = [];
      _requests.push(action.payload);
      if (!app._.isEmpty(requests)) {
        _requests.push(...requests);
      }
      return Object.assign({}, state, {
        requests: _requests,
      });
    case UPDATE_INBOX_REQUEST_SUCCESS:
      _index = requests.findIndex(
        (_request) => _request.id === action.payload.id
      );
      requests[_index] = action.payload;
      return Object.assign({}, state, {
        requests,
      });
    case DESTROY_INBOX_REQUEST_SUCCESS:
      _index = requests.findIndex((_request) => _request.id === action.payload);
      requests.splice(_index, 1);
      return Object.assign({}, state, {
        requests,
      });
    case DESTROY_APPROVE_INBOX_REQUEST_SUCCESS:
      _index = requests.findIndex(
        (_request) => _request.id === action.payload.id
      );
      requests[_index].status = action.payload.status;
      requests[_index].active = 0;
      requests[_index].className = "change-Status";
      return Object.assign({}, state, {
        requests,
      });
      case ACCEPT_ALL_REQUEST_SUCCESS:
      let newArray = action.payload?.data.map((item) => {
        return { id: item.id, status: item.status };
      });
      for (let element of newArray) {
        _index = requests.findIndex(
          (_request) => _request.requestId === element.id
        );
        console.log("_in_inde_indexxdex", element);

        requests[_index].status = element.status;
        requests[_index].active = 0;
        requests[_index].className = "change-Status";
      }

      return Object.assign({}, state, {
        requests,
      });
    // case ACCEPT_ALL_REQUEST_SUCCESS:
    //   clockings = app._.cloneDeep(state.clockings);
    //   if (
    //     !app._.isEmpty(action.payload.ids) &&
    //     action.payload.ids.filterGroups &&
    //     action.payload.ids.filterGroups[0] &&
    //     action.payload.ids.filterGroups[0].filters &&
    //     action.payload.ids.filterGroups[0].filters[0] &&
    //     action.payload.ids.filterGroups[0].filters[0].value
    //   ) {
    //     _temp = action.payload.ids.filterGroups[0].filters[0].value;
    //     for (let x in _temp) {
    //       _index = clockings.findIndex(
    //         (_clocking) => _clocking.id === _temp[x]
    //       );
    //       if (_index > -1) {
    //         _clock = clockings[_index];
    //         _clock.className = _clock.deletedAt
    //           ? "record-deleted"
    //           : `record-${action.payload.status}`;
    //         _clock.rowSelectionDisabled = _clock.deletedAt ? true : false;
    //         _clock.status = action.payload.status;
    //         clockings[_index] = _clock;
    //       }
    //     }
    //   }
    //   return Object.assign({}, state, {
    //     clockings,
    //   });
    default:
      return state;
  }
}
